module.exports = __webpack_public_path__ + "img/TrackNordic-logo-light-60h.bca5982b.png";